import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { Controls, validators } from 'shared/helper/form';
import RubriqSetupStepBackLink from './RubriqSetupStepBackLink';
var RubriqSetupGeneralStep = function RubriqSetupGeneralStep(_ref) {
  var methodsStep = _ref.methodsStep,
    handleSubmit = _ref.handleSubmit,
    stepConfig = _ref.stepConfig,
    submitting = _ref.submitting,
    session = _ref.session,
    previousStep = _ref.previousStep;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var Form = Controls.Form,
    Radio = Controls.Radio;
  var notEmpty = validators.notEmpty;
  return /*#__PURE__*/React.createElement(Form, {
    methods: methodsStep,
    onSubmit: handleSubmit,
    className: "d-flex flex-column gap-sm-4 justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "m-0 fw-semibold"
  }, /*#__PURE__*/React.createElement(T, {
    source: stepConfig.prompt
  })), /*#__PURE__*/React.createElement(Radio, {
    name: "response",
    validators: {
      notEmpty: notEmpty
    },
    styles: {
      formCheck: 'mb-3',
      wrapper: 'rubriq-control-group mt-3'
    },
    options: stepConfig.possibleResponses.map(function (response) {
      var value = response.value;
      return {
        label: t(value),
        value: value
      };
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between gap-3"
  }, /*#__PURE__*/React.createElement(RubriqSetupStepBackLink, {
    session: session,
    previousStep: previousStep
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-squared py-1 px-sm-5 w-mobile-50",
    disabled: !methodsStep.formState.isValid || submitting
  }, /*#__PURE__*/React.createElement(T, {
    source: "next"
  }), submitting && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "ms-1",
    spin: true
  }))));
};
export default RubriqSetupGeneralStep;